import React, { useEffect, useState } from 'react';
import { connect, WithStore, MapStateToProps, MapDispatchToProps } from '../../redux/services/Imports';
import './Up.scss';
import './Up-media.scss';
import { Props } from './interfaces';

const Up = ({ widthWindow }: Props) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleScroll = () => {
    const top = widthWindow > 720 ? 900 : 450;
    window.scrollY < top ? setShow(false) : setShow(true);
  };

  const ScrollToTop = () => window.scrollTo(0, 0);

  return (
    <div
      className="up"
      onClick={ScrollToTop}
      style={show ? { opacity: '1', pointerEvents: 'all' } : { opacity: '0', pointerEvents: 'none' }}
    />
  );
};

export default WithStore()(connect(MapStateToProps, MapDispatchToProps)(Up));
